export enum BarDesign {
  Auto = 'Auto',
  Footer = 'Footer',
  Header = 'Header',
  SubHeader = 'SubHeader',
  FloatingFooter = 'FloatingFooter'
}
